export default __webpack_public_path__ + "static/media/icon-monCompte-cursus.106b1ab3.svg";